// ISO 3166 complient
// https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
enum CountryCode {
    AU = "AU", // Australia
    AT = "AT", // Austria
    BE = "BE", // Belgium
    CA = "CA", // Canada
    DK = "DK", // Denmark
    FI = "FI", // Finland
    FR = "FR", // France
    DE = "DE", // Germany
    IT = "IT", // Italy
    NL = "NL", // Netherlands
    NZ = "NZ", // New Zealand
    NO = "NO", // Norway
    PL = "PL", // Poland
    ES = "ES", // Spain
    SE = "SE", // Sweden
    CH = "CH", // Switzerland
    GB = "GB", // Great Britain
    US = "US", // The United States of America
}

export default CountryCode;
